import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  TabActionDialog
} from "../types";

const storeSectionUrl = "/store/";

export enum TenantListUrlFiltersEnum {
  brand = "brand",
  status = "status",
  query = "query",
  isFeatured = "isFeatured"
}

export type StoreListUrlFilters = Filters<TenantListUrlFiltersEnum>;
export type StoreListUrlDialog = TabActionDialog;
export type StoreListUrlQueryParams = ActiveTab &
  BulkAction &
  StoreListUrlFilters &
  Dialog<StoreListUrlDialog> &
  Pagination;
export type StoreUrlQueryParams = Pagination;

export const storeListPath = storeSectionUrl;

export const storeListUrl = (params?: StoreListUrlQueryParams) =>
  storeSectionUrl + "?" + stringifyQs(params);

export const storePath = (id: string) => urlJoin(storeSectionUrl, id);

export const storeUrl = (id: string, params?: StoreUrlQueryParams) =>
  storePath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const storeAddPath = urlJoin(storeSectionUrl, "add");

export const storeAddUrl = () => storeAddPath;
